module.exports = __webpack_public_path__ + "img/cltts_logo.395081d7.png";